import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  total_purchase: '',
  total_tax: '',
  total_refund: '',
  total_service_charges: '',
  idle_time_total: '', // Added missing property
  verified: false,
  verify: {
    total_purchase: false,
    total_tax: false,
    total_refund: false,
    total_service_charges: false,
    verified: false
  }
}

export const purchaseTotalSlice = createSlice({
  name: 'purchase_total',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setPurchaseTotal: (state, action) => {
      // With Redux Toolkit + Immer, we can mutate the state directly
      Object.assign(state, action.payload)
    },
    initializePurchaseTotal: state => {
      // Reset all properties to initial state values
      Object.assign(state, initialState)
    },
    setPurchaseTotalVerify: (state, action) => {
      Object.assign(state.verify, action.payload)
    },
    verifyAllPurchaseTotal: (state, action) => {
      // Use forEach instead of map since we're not returning anything
      // Use const instead of var for better scoping
      const verifyKeys = Object.keys(state.verify)
      verifyKeys.forEach(key => {
        state.verify[key] = action.payload
      })
    },
    setIdleTimeTotal: (state, action) => {
      // Simplified - directly mutate with Immer
      state.idle_time_total = action.payload
    },
    setPurchaseTotalFromAPI: (state, action) => {
      state.total_purchase = action.payload.total_purchase
      state.total_tax = action.payload.total_tax
      state.total_refund = action.payload.total_refund
      state.total_service_charges = action.payload.total_service_charges
      state.idle_time_total = action.payload.idle_time_total
      state.verify = action.payload.verify
      state.verified = action.payload.verified
    }
  }
})

export const {
  setPurchaseTotal,
  initializePurchaseTotal,
  setPurchaseTotalVerify,
  verifyAllPurchaseTotal,
  setIdleTimeTotal,
  setPurchaseTotalFromAPI
} = purchaseTotalSlice.actions

export default purchaseTotalSlice.reducer
